// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"766":"css/login","1174":"css/legal","2538":"css/showGame","3155":"css/control-panel","5049":"css/configure","5074":"css/home","6890":"css/news","7402":"css/knowledgebase","8204":"css/games","9517":"css/404"}[chunkId] + ".css";
};